<script setup lang="ts">
type Props = {
  rounded?: boolean;
};

const { rounded = false } = defineProps<Props>();

const { bannerImage, showModalImage } = useModalImage();
</script>

<template>
  <div
    v-if="showModalImage"
    class="select-none w-full h-auto md:h-full flex items-center justify-center"
  >
    <img
      v-if="bannerImage"
      :alt="appName()"
      class="w-[95%] rounded-[20px]"
      :class="[{ 'rounded-lg': rounded }]"
      :src="bannerImage"
    />
  </div>
</template>
